import React, { Component, Fragment } from 'react'
import { Link } from "react-router-dom";
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Container,Row,Col, Form,Button } from 'react-bootstrap'
import Product1 from '../../assets/images/service/cameraservices.png'





class CctvCameras extends Component {
     render() {
          return (
               <Fragment>
              <Container fluid={true}  className="BetweenTwoSection">
                           <div className="breadbody">
               <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
    <Breadcrumb.Item> <Link to=""> Service </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/networking"> computer Network</Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>
           <h2 className="section-title text-center mb-2 text-primary">CCTV Camera Installation Services</h2>

     <p className="text-center mb-3">Professional and experienced technicians</p>
                   <Row className="">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={12} xs={12}>
           <img  className="product-main"  src={Product1}  alt="ParkEase Dashboard"/>
          <Container  className="my-3">
              
          </Container>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
            <h4>CCTV Camera Installation Services</h4>
            <h5>Protect Your Business and Property with Reliable CCTV Surveillance Solutions</h5>
          
          <p>At ChrisAlpha Tech, we provide professional CCTV camera installation and surveillance solutions designed to enhance security for homes, businesses, offices, schools, and organizations. 
            Our systems help you monitor activities in real-time, prevent theft, and ensure safety for people and property.</p>
            <p>We supply high-quality cameras, install them professionally, and provide ongoing maintenance and support to ensure your security system operates efficiently 24/7.</p>

          <div className="">
           <h6>Our CCTV Services Include:</h6>
             <ul className="login-steps">
            <li>CCTV camera supply and installation</li>
            <li>Indoor and outdoor camera setup</li>
            <li>Wireless and wired CCTV systems</li>
            <li>Remote viewing setup on mobile phones</li>
             <li>DVR and NVR configuration</li>
            <li>System maintenance and repair</li>
            <li>Security consultation and site assessment</li>

            </ul>
         

          </div>
          </Col>
     </Row>

     <Row>
          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2"></h6>
          <h6>Why Choose ChrisAlpha Tech for CCTV Installation?</h6>
             <ul className="login-steps">
            <li>Professional and experienced technicians</li>
            <li>High-quality and reliable equipment</li>
            <li>Affordable installation packages</li>
            <li>Fast and secure setup</li>
             <li>Ongoing technical support and maintenance</li>
            <li>Customized security solutions</li>
     

            </ul>
        
          </Col>

          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">REVIEWS</h6>
          <p className=" p-0 m-0"><span className="Review-Title"> Stay Connected, Stay Secure. </span><span className="text-success"> </span>    </p>
          <p>With ChrisAlpha Tech’s CCTV solutions, you can watch over your property in real-time, control your cameras remotely, and protect what matters most — anytime, anywhere.</p>

          <p className=" p-0 m-0"><span className="Review-Title">Watch Over What Matters, Anytime, Anywhere.</span> <span className="text-success"> </span> </p>
          <p>Protect your home, office, or business with our professional CCTV solutions. Monitor live footage, review recordings, and stay connected to your property no matter where you are.</p>

          </Col>
     </Row>
</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default CctvCameras